export default __webpack_public_path__ + "static/media/3.0a274fd0.png";